export default {
  columns: {
    strategy: 'Strategia',
    source: 'Źródło',
    async: 'Async',
    content: 'Treść',
    edit: 'Edytuj',
    delete: 'Usuń',
  },
  buttons: {
    add_script: 'Dodaj skrypt',
  },
};
